import React from "react";
import { Navigate } from "react-router-dom";
import Login from "./Login";

const isLoginDomain = () => {
  const hostname = window.location.hostname;
  const loginDomain = process.env.REACT_APP_LOGIN_DOMAIN || 'login.dastaan.info';
  return hostname === loginDomain || process.env.REACT_APP_DOMAIN === 'login';
};

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("dastaan__token");
  const skipped = sessionStorage.getItem('dastaan__login_skipped') === 'true';
  const planId = localStorage.getItem("dastaan__plan_id");

  if (!token && !skipped) {
    return <Login />;
  }

  // On login.dastaan.info, users must have an active subscription to access content
  if (token && isLoginDomain()) {
    const hasValidPlanId = planId && planId !== 'null' && planId !== 'undefined' && planId !== '';
    const hasSubscription = hasValidPlanId || localStorage.getItem("dastaan__plan_active") === 'true';
    if (!hasSubscription) {
      return <Navigate to="/plans" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
